import React, { useState } from 'react';
import { Send, User, Mail, MessageSquare, Phone } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission - will be replaced with backend later
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', phone: '', message: '' });
    }, 3000);
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header animate-fade-in-up">
          <h2 className="section-title">Make a Reservation</h2>
          <div className="title-divider"></div>
          <p className="section-subtitle">Book your table or send us a message</p>
        </div>

        <div className="contact-content">
          <form action="https://api.web3forms.com/submit" method="POST" className="contact-form">
    {/* Web3Forms Engine */}
    <input type="hidden" name="access_key" value="48088a3c-b9a6-46a3-a9aa-4f3aa2261c8e" />
    <input type="hidden" name="redirect" value="https://kothurotti.co.uk" />
            <div className="form-group">
              <label className="form-label">
                <User size={18} />
                Full Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter your name"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <Mail size={18} />
                Email Address
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                placeholder="your.email@example.com"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <Phone size={18} />
                Phone Number
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
                placeholder="0141 378 3469"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <MessageSquare size={18} />
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="form-textarea"
                placeholder="Tell us about your reservation..."
                rows="5"
                required
              ></textarea>
            </div>

            <button type="submit" className="btn-primary submit-btn" disabled={isSubmitted}>
              {isSubmitted ? 'Message Sent!' : (
                <>
                  <Send size={20} />
                  Send Message
                </>
              )}
            </button>
          </form>

          <div className="contact-info">
            <div className="info-item hover-lift">
              <h3 className="info-heading">Quick Contact</h3>
              <p className="info-description">
                For immediate reservations or inquiries, give us a call
              </p>
              <a href="tel:0141 378 3469" className="contact-link">
                <Phone size={20} />
                0141 378 3469
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
